// extracted by mini-css-extract-plugin
export default {"card":"TaskCard_card__QbGIX","container":"TaskCard_container__3Bkhv","header":"TaskCard_header__hiT0-"};